import { createFileRoute } from '@tanstack/react-router';
import { ManageBrandingPage } from '@/pages/member-portal/branding/ManageBrandingPage';

// Branding assets authoring — upload, organize, and publish branding assets.
function MemberPortalManageBrandingRoute() {
	return <ManageBrandingPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/branding')({
	component: MemberPortalManageBrandingRoute,
});
